import type { ReactElement } from "react"
import FormilyFormLink from "@gatsby-plugin-generic-page/components/FormilyFormLink"
import type { Formily } from "@gatsby-plugin-generic-page/fragments/formily"
import type { SquidexLinkType } from "@gatsby-plugin-generic-page/types/ctaElementType"
import { SquidexFormType } from "@gatsby-plugin-generic-page/types/formType"
import { typeMatches } from "@onestore-graphql"
import type { Forms } from "~/types/squidex"

interface Props {
  text: string
  title: string
  form: Forms[]
  linkType?: SquidexLinkType
}

export default function FormLink({
  title,
  text,
  form,
  linkType,
}: Props): ReactElement<Props> | null {
  const { __typename } = form[0]

  if (!typeMatches(__typename, SquidexFormType.FORMILY_FORM)) {
    return null
  }

  return (
    <FormilyFormLink
      title={title}
      text={text}
      formilyForm={form[0] as Formily}
      linkType={linkType}
    />
  )
}
